import { Navigate } from "react-router";
import { Button } from "../../components/Button";
import Layout from "../../components/Layout";
import { ServiceProviderType, ServiceTypeEnum } from "../../types/Building";
import RealPageRentContainer from "../checklist/rent-real-page";
import useLivlyUser from "../../context/UserProvider";
import BiltContainer from "./serviceProviders/bilt";
import ClickPayContainer from "./serviceProviders/click-pay";

export default function RentPage() {
  const { user } = useLivlyUser();
  const rentService = user.building.serviceTypes?.find(
    (serviceType) => serviceType.serviceType === ServiceTypeEnum.Rent
  );

  const isRentExternal =
    rentService?.serviceProviderType === ServiceProviderType.External;
  const isRentClickPay =
    rentService?.serviceProviderType === ServiceProviderType.ClickPay;
  const isRentRealPage =
    rentService?.serviceProviderType === ServiceProviderType.RealPage;
  const isRentBilt =
    rentService?.serviceProviderType === ServiceProviderType.Bilt;

  if (isRentBilt) {
    return <BiltContainer title={rentService?.displayName ?? "Rent"} />;
  }

  if (isRentExternal) {
    return (
      <div className="flex items-center justify-center h-screen">
        <a href={rentService?.url} target="_blank" rel="noopener noreferrer">
          <Button color="secondary">Click Here</Button>
        </a>
      </div>
    );
  }

  if (isRentClickPay) {
    return (
      <ClickPayContainer
        leaseId={user.propertyUnitLeaseId}
        title={rentService?.displayName ?? "Rent"}
      />
    );
  }

  if (isRentRealPage) {
    return (
      <Layout title={rentService?.displayName ?? "Rent"}>
        <RealPageRentContainer leaseId={user.propertyUnitLeaseId} />
      </Layout>
    );
  }

  return <Navigate to="livly" replace />;
}
